import React from 'react';
import { Input, Select } from 'components';
/*
 * If I can delete this file
 * No specific code for the client left
 */

export const DinumSpecialConf = {
  orgId: '23045ba8-16f6-461c-b200-47273d8244cb',
  panelId: '92fc2d1f-e99c-49ed-9eb8-99c3cf26f7e2',
  specialFields: [
    {
      name: '__dinumStatus',
      participantLabel: 'Statut',
      clientLabel: 'Statut',
      formComponent: (props: { name: string; label: string }) => (
        <Select
          options={[
            'Exonéré',
            'Payé',
            'Payé par un tiers',
            'Remboursé',
            'Boursier',
          ]}
          {...props}
        />
      ),
    },
    {
      name: '__dinumINE',
      participantLabel: 'INE',
      clientLabel: 'INE',
      formComponent: Input,
    },
    {
      name: '__dinumBoursier',
      participantLabel: 'Boursier',
      clientLabel: 'Boursier',
      formComponent: Input,
    },
  ],
};
